import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { Dropdown } from 'react-bootstrap';

import '../Styles/Components/AppDropdown.scss';

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href="#/"
        className="App--Dropdown-A-Tag"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <span className="App--Dropdown-Chev" ><FontAwesomeIcon icon={faChevronDown} /></span>

    </a>
));


export default function AppDropdown(props) {
    var darktone = props.darktone ? 'true' : 'false';
    return (
        < Dropdown >
            <div className={props.isFlexRow ? "App--Dropdown-Flex-Row" : ""}>
                {
                    props.icon ?
                        <span className="App--Dropdown-Icon" >{props.icon}</span> :
                        null
                }
                <Dropdown.Toggle as={CustomToggle}>
                    <span darktone={darktone} className={props.className} style={{ ...props.style }}>
                        {props.defaultvalue}
                    </span>
                </Dropdown.Toggle>
            </div>

            <Dropdown.Menu className="App--Dropdown-Menu" alignRight={props.alignright}>
                {
                    props.headertitle ?
                        <Dropdown.Header>{props.headertitle}</Dropdown.Header> : null
                }
                {
                    props.items ?
                        props.items.map((item, index) => {
                            return <Dropdown.Item onSelect={(index) => { props.onSelect(parseInt(index)) }} className="App--Dropdown-Menu-Item" active={index === props.activeindex ? true : false} key={index} eventKey={index}>{item}</Dropdown.Item>
                        }) : console.error("This component requires that you add an array of strings to the 'items' prop")

                }
            </Dropdown.Menu>
        </Dropdown >
    );
}
